<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <AppHeader :title="$t('special_student_applications')"
                        :isNewButton="false"
                        @filter-div-status="datatable.filterStatus = $event">
                </AppHeader>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('special_student_applications')"
                              :isNewButton="false"
                              @filter-div-status="datatable.filterStatus = $event">
                </HeaderMobile>
            </template>

            <DatatableFilter
             v-show="datatable.filterStatus"
             :exportExcel="true"
             @filter="filter" @filterClear="filterClear" @exportExcel="exportExcel">
                <b-tabs content-class="mt-3">
                    <b-tab :title="$t('personal_information')" active>
                        <b-row>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('national_id')">
                                    <b-form-input size="sm" v-model="datatable.queryParams.filter.national_id"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('name')">
                                    <b-form-input size="sm" v-model="datatable.queryParams.filter.name"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('surname')">
                                    <b-form-input size="sm" v-model="datatable.queryParams.filter.surname"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('nationality')">
                                    <CountrySelectbox
                                        v-model="datatable.queryParams.filter.nationality"
                                        valueType="code"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab :title="$t('program_information')">
                        <b-row>
                            <b-col sm="6" md="4">
                                <b-form-group :label="$t('academic_year')">
                                    <AcademicYearsSelectbox
                                        v-model="datatable.queryParams.filter.term"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="4">
                                <b-form-group :label="$t('program_level')">
                                    <ParameterSelectbox
                                        v-model="datatable.queryParams.filter.level"
                                        code="program_levels"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="4">
                                <b-form-group :label="$t('faculty')">
                                    <FacultySelectbox
                                        v-model="datatable.queryParams.filter.faculty"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="4">
                                <b-form-group :label="$t('department')">
                                    <DepartmentSelectbox
                                        :faculty_code="datatable.queryParams.filter.faculty"
                                        v-model="datatable.queryParams.filter.department"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="8">
                                <b-form-group :label="$t('program')">
                                    <ProgramSelectbox
                                        :faculty_code="datatable.queryParams.filter.faculty"
                                        :department_code="datatable.queryParams.filter.department"
                                        v-model="datatable.queryParams.filter.program"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="4">
                                <b-form-group :label="$t('with_without_thesis')">
                                    <ThesisWithTrueFalseSelectbox
                                        v-model="datatable.queryParams.filter.thesis"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab :title="$t('application_information')">
                        <b-row>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('accepttance_status')">
                                    <parameter-selectbox v-model="datatable.queryParams.filter.acceptance_status" code="special_student_application_acceptance_statuses"/>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('application_completion_status')">
                                    <parameter-selectbox v-model="datatable.queryParams.filter.completion_status" code="special_student_application_completion_statuses" />
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('application_status')">
                                    <parameter-selectbox v-model="datatable.queryParams.filter.application_status" code="special_student_application_statuses"/>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" md="3">
                                <b-form-group :label="$t('application_type')">
                                    <parameter-selectbox v-model="datatable.queryParams.filter.registration_type" code="application_type_code"/>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-tab>
                </b-tabs>
            </DatatableFilter>

            <!-- Datatable -->
            <Datatable
                :isLoading.sync="datatable.isLoading"
                :columns="datatable.columns"
                :rows="datatable.rows"
                :total="datatable.total"
                :queryParams="datatable.queryParams"
                :lineNumbers="false"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable"
            ></Datatable>



            <CommonModal ref="editFormModal" size="xxl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <EditModal
                        v-if="formProcess === 'edit'"
                        :application="selectedApplication"
                        @saved="editFormSuccess"
                    />
                </template>
            </CommonModal>

            <CommonModal ref="showFormModal" size="xl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('special_student').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <ShowModal
                        v-if="formProcess === 'show'"
                        :application="selectedApplication"
                    />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>

<script>
import AppLayout from "@/layouts/AppLayout";
import AppHeader from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";
import Datatable from "@/components/datatable/Datatable.vue";
import DatatableFilter from "@/components/datatable/DatatableFilter.vue";
import CommonModal from "@/components/elements/CommonModal.vue";
import EditModal from "../components/EditModal.vue";
import ShowModal from "../components/ShowModal.vue";
import CountrySelectbox from "@/components/interactive-fields/CountrySelectbox.vue";
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox.vue";
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue";
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox.vue";
import DepartmentSelectbox from "@/components/interactive-fields/DepartmentSelectbox.vue";
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox.vue";
import ThesisWithTrueFalseSelectbox from "@/components/interactive-fields/ThesisWithTrueFalseSelectbox.vue";
import SpecialStudentApplicationService from "@/services/SpecialStudentApplicationService";
import qs from 'qs';


export default {
    name: "AdminSpecialStudentIndex",
    components: {
        AppLayout,
        AppHeader,
        HeaderMobile,
        Datatable,
        DatatableFilter,
        CommonModal,
        EditModal,
        ShowModal,
        CountrySelectbox,
        AcademicYearsSelectbox,
        ParameterSelectbox,
        FacultySelectbox,
        DepartmentSelectbox,
        ProgramSelectbox,
        ThesisWithTrueFalseSelectbox
    },
    metaInfo() {
        return {
            title: this.$t('special_student_applications')
        }
    },
    computed:{
        getActiveRol() {
            return this.$store.getters['auth/getActiveRole']
        },
    },
    data() {
        return {
            formProcess: null,
            selectedApplication: null,
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            { text: this.$t('show'), class: 'ri-search-eye-line', callback: this.viewRow },
                            { text: this.$t('edit'), class: 'ri-edit-box-line', callback: this.editRow,
                                show:((row)=>{
                                   return (!['document_waiting'].includes(row.application_status) || row.application_status===null) && !['A'].includes(this.getActiveRol) && this.checkActiveStep(row).includes(this.getActiveRol)
                                }) },
                            { text: this.$t('download'), class: 'ri-download-line', callback: this.downloadRow },
                            { text: this.$t('delete'), class: 'ri-delete-bin-2-line', callback: this.deleteRow }
                        ]
                    },
                    { label: this.$t('academic_year'), field: 'academic_year', sortable: false },
                    { label: this.$t('national_id'), field: 'national_id', sortable: false },
                    { label: this.$t('name'), field: 'name', sortable: false },
                    { label: this.$t('surname'), field: 'surname', sortable: false },
                    { label: this.$t('program'), field: this.getLocaleField('bau_program_name'), sortable: false },
                    // { label: this.$t('application_completion_status'), field: this.getLocaleField('completion_status_name'), sortable: false },
                    { label: this.$t('application_status'), field: this.getLocaleField('application_status_name'), sortable: false },
                ],
                rows: [],
                total: 1,
                filterStatus: true,
                showTable: true,
                queryParams: {
                    filter: {},
                    sort: 'id',
                    page: 1,
                    limit: 15
                }
            }
        }
    },
    mounted() {
        this.getRows();
    },
    methods: {
        checkActiveStep(data){
            const status = data.application_status ?? null
            let rol = [];
            if (['waiting_approval', 'document_waiting', 'rejected'].includes(status)) {
                rol = ['OI'];
            } else if (['waiting_secretary_approval', 'course_rejected'].includes(status)) {
                rol = ['FS', 'FSY', 'ES', 'ESY'];
            }
            return rol
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            SpecialStudentApplicationService.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;
                })
                .catch((error) => {
                    if (error.data && error.data.message) {
                        this.$toast.error(this.$t('api.' + error.data.message));
                    }
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        exportExcel() {
            const config = {
                params: { ...this.datatable.queryParams }
            };
            SpecialStudentApplicationService.exportExcel(config).then(response => {
                this._downloadFile(response, this.$t('special_student_applications') + '.xlsx')
            }).catch(e => {
                this.showErrors(e,null,true)
            });
        },
        formClear() {
            this.formProcess = null;
            this.selectedApplication = null;
        },

        viewRow(row) {
            this.datatable.isLoading = true;
            SpecialStudentApplicationService.get(row.id).then(response => {
                this.selectedApplication = response.data.data;
                this.formProcess = 'show';
                this.$refs.showFormModal.$refs.commonModal.show();
            }).finally(() => {
                this.datatable.isLoading = false;
            });
        },
        editRow(row) {
            this.datatable.isLoading = true;
            SpecialStudentApplicationService.get(row.id).then(response => {
                this.selectedApplication = response.data.data;
                this.formProcess = 'edit';
                this.$refs.editFormModal.$refs.commonModal.show();
            }).finally(() => {
                this.datatable.isLoading = false;
            });
        },
        editFormSuccess() {
            this.$refs.editFormModal.$refs.commonModal.hide();
            this.filter();
            this.formClear();
        },
        downloadRow(row) {
            SpecialStudentApplicationService.downloadForm(row.id).then(response => {
                this._downloadFile(response, row.name+'-'+row.surname+'.'+(response.headers.file_extension??'pdf'))
            }).catch(e => {
              this.showErrors(e,null,true)
            });
        },
        deleteRow(row) {
            this.deleteModal(() => {
                SpecialStudentApplicationService.deleteApplication(row.id)
                    .then((response) => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                         this.getRows()
                    })
                    .catch((error) => {
                        this.showErrors(error,null)
                    });
            });
        }
    }
}
</script>

<style scoped>
</style>
